<template>
    <div>
        <main id="main" class="has-nav">
            <div class="container">

                <div class="title-wrapper terminals">
                    <h1 class="title line">Manage LX Terminals</h1>
                    <div class="buttons-box">
                        <a href="#" class="btn light-green" @click.prevent="exportClick">
                            <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-exel/></icon-base>
                            <span>Export to XLS</span>
                        </a>
                        <a href="#" class="btn success" @click.prevent="addNewTerminal">
                            <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-plus color="white"/></icon-base>
                            <span>Add new</span>
                        </a>
                    </div>
                </div>

                <div class="sort-wrapper">
                    <div class="sort-box">
                        <span>Sort by:</span>
                        <p class="item" :class="openSort ? 'active' : ''" @click="openSort = !openSort">
                            <span>{{sortParam}}</span>
                            <icon-base width="11" height="7" viewBox="0 0 11 7"><icon-arrow-down/></icon-base>
                        </p>
                    </div>
                    <div class="mobile-filter-box">
                            <span class="mobile-filter-btn" @click.prevent="mobileFilterClick">
                                <icon-base width="15" height="15" viewBox="0 0 15 15" ><icon-filter-mobile/></icon-base>
                                <span>Filter</span>
                            </span>
                    </div>
                </div>
                <div class="table-box">
                    <div class="table terminals-table">
                        <div class="table-head" :style="openSort ? 'display: flex;': ''">
                            <simple-table-filter name="customer_id" label="Customer" @filter="filterClick" :param="filterParam" class="customer-col"/>
                            <simple-table-filter name="type_id" label="Terminal Type" @filter="filterClick" :param="filterParam" class="terminal-col" :filter="true" type="select" :options="typeOptions"/>
                            <simple-table-filter name="core_module_id" label="Core Module ID" @filter="filterClick" :param="filterParam" :filter="true" class="core-module-col"/>
                            <simple-table-filter name="subscription_id" label="Active Subscription" @filter="filterClick" :param="filterParam" class="subscription-col"  type="select" :filter="true" :options="subscriptionOptions"/>
                            <simple-table-filter name="created_at" label="Created" @filter="filterClick" :param="filterParam" class="creaded-col" type="date" :filter="true"/>
                            <div class="col btn-col"></div>
                        </div>

                        <div class="table-body" :class="loading ? 'loading' : ''">
                            <div class="row"  v-for="(terminal, index) in terminals" v-bind:key="index">
                                <div class="col customer-col"><p>{{getCompany(terminal.client_id)}}</p></div>
                                <div class="col terminal-col"><p>{{getName('terminalTypes' ,terminal.type_id)}}</p></div>
                                <div class="col core-module-col"><p>{{terminal.core_module_id}}</p></div>
                                <div class="col subscription-col"><p>{{getName('subscriptions' ,terminal.subscription_id)}}</p></div>
                                <div class="col creaded-col"><p class="title">Creaded:</p>
                                    <p class="creaded-col-date">{{getDate(terminal.created_at)}}</p>
                                    <p class="creaded-col-time">{{getTime(terminal.created_at)}}</p>
                                </div>
                                <div class="col btn-col">
                                    <a href="#" class="extend-btn light-green small-btn" data-title="Edit" @click.prevent="editTerminal(terminal)">
                                        <icon-base width="25" height="25" viewBox="0 0 25 25"><icon-pencil/></icon-base>
                                        <span>Edit</span>
                                    </a>
                                    <a href="#" class="delete-btn light-red small-btn" data-title="Delete" @click.prevent="delTerminal(terminal.id)">
                                        <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-trash/></icon-base>
                                        <span>Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <a href="" class="js-show-more" @click.prevent="loadMore" v-if="loadMoreTerminals">Show more</a>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

import {mapActions, mapState, mapMutations} from "vuex"
import IconBase from "../common/IconBase";
import IconPlus from "../common/icons/IconPlus";
import SaveDialog from "../common/SaveDialog"
import IconExel from "../common/icons/IconExel";
import TerminalForm from "./Terminals/TerminalForm";
import TerminalFilterForm from "./Terminals/TerminalFilterForm";
import Confirm from "../common/Confirm"
import IconTrash from "../common/icons/IconTrash";
import dateformat from "dateformat"
import IconPencil from "../common/icons/IconPencil";
import SimpleTableFilter from "../common/SimpleTableFilter";
import IconArrowDown from "../common/icons/IconArrowDonw";
import IconFilterMobile from "../common/icons/IconFilterMobile";

export default {
    name: 'lx-terminals',

    components: {IconFilterMobile, IconArrowDown, SimpleTableFilter, IconPencil, IconTrash, IconExel, IconPlus, IconBase},

    computed: {
        ...mapState('terminals', [
            'terminals',
            'loadMoreTerminals',
            'customers',
            'terminalTypes',
            'subscriptions'
        ]),
    },

    data() {
        return {
            currentPage: 1,
            loading: false,
            filterParam: 'created_at',
            searchParam: '',
            order: true,
            openSort: false,
            typeOptions: [],
            subscriptionOptions: [],
            sortParam: 'Company',
        }
    },

    methods: {
        ...mapActions('terminals', [
            'loadTerminals',
            'loadOptions',
            'addTerminal',
            'deleteTerminal',
            'updateTerminal',
            'exportTerminals',
        ]),
        ...mapMutations([
            'switchPopup',
            'setPopupComponent',
            'setPopupData'
        ]),
        ...mapMutations('terminals', [
            'reset',
        ]),
        addNewTerminal() {
            this.setPopupComponent(TerminalForm);
            this.setPopupData({type: 'add', func: this.addTerminal });
            this.switchPopup(true);
        },
        editTerminal(terminal) {
            this.setPopupComponent(TerminalForm);
            this.setPopupData({type: 'edit', item: terminal, func: this.updateTerminal });
            this.switchPopup(true);
        },
        delTerminal(id) {
            this.setPopupComponent(Confirm);
            this.setPopupData({id: id, func: this.deleteTerminal });
            this.switchPopup(true);
        },
        exportClick() {
            this.setPopupComponent(SaveDialog);
            this.setPopupData({func: this.exportTerminals});
            this.switchPopup(true);
        },
        getDate(time) {
            return dateformat(time * 1000, "dd.mm.yy");
        },
        getTime(time) {
            return dateformat(time * 1000, "h:MM TT");
        },
        getName(type, id) {
            let name = '';
            this[type].forEach(obj => {
                if (obj.id === id) name = obj.name
            });
            return name
        },
        getCompany(id) {
            let name = '';
            this.customers.forEach(obj => {
                if (obj.id === id) name = obj.company
            });
            return name
        },
        filterClick(value) {
            this.filterParam = value.name;
            this.order = value.order;
            this.openSort = false;

            let params = {sort: !this.order ? '-' + this.filterParam : this.filterParam};
            if (value.name === 'created_at') {
                params["TerminalSearch[created_at_from]"] = value.search.from;
                params["TerminalSearch[created_at_to]"] = value.search.to;
            }
            else if (value.search) {
                params["TerminalSearch[" + this.filterParam + "]"] = value.search;
            }
            if (this.filterParam) {
                this.loading = true;
                this.reset();
                this.currentPage = 1;
                this.loadTerminals(params).then(() => {
                    this.loading = false;
                });
            }
        },
        mobileFilterClick() {
            this.setPopupComponent(TerminalFilterForm);
            //this.setPopupData();
            this.switchPopup(true);
        },
        loadMore() {
            this.loading = true;
            this.currentPage += 1;
            this.loadTerminals({sort: !this.order ? '-' + this.filterParam : this.filterParam, page: this.currentPage}).then(() => {
                this.loading = false;
            });
        }

    },

    mounted() {
        this.loading = true;
        this.loadTerminals({sort: this.order ? '-' + this.filterParam : this.filterParam, page: 0}).then(() => {
            this.loading = false;
        });

        this.loadOptions();

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
